import { getGraphQlEndpoint } from '@/libs/core/graphql-client';
import { getAccessToken } from 'axios-jwt';
import { v4 as uuidv4 } from 'uuid';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';

export async function graphqlPost<T = any>(query: string, variables?: any): Promise<T | null> {
    try {
        const endpoint = getGraphQlEndpoint();
        const token = getAccessToken();
        const tenant: string = authStore.useGetter(AuthGetter.GetTenant) ?? '';
        const correlationId = uuidv4();
        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : '',
            'TenantId': tenant,
            'CorrelationId': correlationId,
        };
        const signalClientId = (window as any).SignalClientId as string | undefined;
        if (signalClientId) headers['SignalClientId'] = signalClientId;

        // Logging – odhadni název operace
        const opMatch = /\b(query|mutation)\s+(\w+)/i.exec(query || '');
        const opName = opMatch ? opMatch[2] : 'unknown';
        const t0 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
        if ((window as any).__TPM_GQL_DEBUG) {
            // eslint-disable-next-line no-console
            console.log('[TPM][GQL][START]', { op: opName, variables, endpoint });
            try { console.log('[TPM][GQL][STACK]', new Error().stack); } catch (e) { /* ignore */ }
        }

        const resp = await fetch(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers,
            body: JSON.stringify({ query, variables }),
        }).then((r) => r.json()).then((data) => {
            if ((window as any).__TPM_GQL_DEBUG) {
                const t1 = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
                // eslint-disable-next-line no-console
                console.log('[TPM][GQL][END]', { op: opName, ms: +(t1 - t0).toFixed(1) });
            }
            return data;
        });
        return (resp && resp.data) || null;
    } catch {
        return null;
    }
}


